import { render, staticRenderFns } from "./BankDetailsForm.vue?vue&type=template&id=1f1a09fc"
import script from "./BankDetailsForm.vue?vue&type=script&lang=js"
export * from "./BankDetailsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports